import { z } from 'zod';
import { zSearchText } from '@/shared/lib/search';

/** Period (YYYY-MM) and bank code live in the URL for every Collections screen. */
export const ledgerSearchSchema = z.object({
  period: z
    .string()
    .regex(/^\d{4}-(0[1-9]|1[0-2])$/)
    .optional()
    .catch(undefined),
  bank: zSearchText(),
});
